module.exports = __webpack_public_path__ + "static/media/team.da6d2a44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/economy/team.svg
// module id = 82
// module chunks = 0